<template>
    <ai-grid-edit
        ref='gridRef'
        :meta='gridMeta'
        :args='gridArgs'
        :to-remove-toolbar-items-names='removeGridToolbarBtns'
    ></ai-grid-edit>
</template>
<script>
export default {
    name: 'ds-period-view',
};
</script>
<script setup>
import { computed, onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';

const gridRef = ref(null);

const commonArgs = {
    depId: +getCookie('dep'),
};

const gridArgs = computed(() => {
    return {
        select: {
            select_args:{...commonArgs}
        },
        save: {
            update_args: {...commonArgs},
        },
    }
});

onMounted(async () => {
    await gridRef.value?.setDataSource();
});

const removeGridToolbarBtns = [ 'edit', 'choice', 'show-column-chooser', 'searchPanel', 'copy', 'export', 'add', 'delete'];

const gridMeta = {

    keyExpr: 'id_period',
    columns: [
        {
            name: 'kod_period',
            caption: 'Устаревший код',
            dataField: 'kod_period',
            allowEditing: false,
            dataType: 'number',
            width: 150,
            index: 1,
            visible: false,
        },
        {
            name: 'id_period',
            caption: 'Код',
            dataField: 'id_period',
            allowEditing: false,
            dataType: 'number',
            width: 150,
            index: 2,
            visible: false,
        },
        {
            name: 'name',
            caption: 'Наименование периода',
            dataField: 'name',
            allowEditing: false,
            width: 200,
            index: 3,
            visible: true,
        },
        {
            name: 'sut',
            caption: 'Кол-во дней',
            dataField: 'sut',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 4,
            visible: true,
        },
        {
            name: 'tnw',
            caption: 'Температура наружного воздуха (С)',
            dataField: 'tnw',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 5,
            visible: true,
            format:  '###,###,###,###,##0.0'
        },
        {
            name: 'tnw_pot',
            caption: 'Температура наружного воздуха для потерь (С)',
            dataField: 'tnw_pot',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 6,
            visible: true,
            format:  '###,###,###,###,##0.0'
        },
        {
            name: 'tt',
            caption: 'Температура холодной воды (С)',
            dataField: 'tt',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 7,
            visible: true,
            format:  '###,###,###,###,##0.0'
        },
        {
            name: 'tgw_p',
            caption: 'Температура в сетях ГВС подающий трубопровод (С)',
            dataField: 'tgw_p',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 8,
            visible: true,
        },
        {
            name: 'tgw_o',
            caption: 'Температура в сетях ГВС обратный трубопровод (С)',
            dataField: 'tgw_o',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 9,
            visible: true,
        },
        {
            name: 'txw_ctp',
            caption: 'Температура холодной воды (С) (расчет ГВС)',
            dataField: 'txw_ctp',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 10,
            visible: true,
            format:  '###,###,###,###,##0.00'
        },
        {
            name: 'sez',
            caption: 'Признак отопительного сезона',
            dataField: 'sez',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 11,
            visible: true,
        },
        {
            name: 'kvartal',
            caption: 'Квартал',
            dataField: 'kvartal',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 12,
            visible: true,
        },
        {
            name: 't_nw_vp',
            caption: 'Температура воздуха в помещении для потерь (С)',
            dataField: 't_nw_vp',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 13,
            visible: true,
            format:  '###,###,###,###,##0.00'
        },
        {
            name: 't_nw_p',
            caption: 'Температура воздуха подвала для потерь (С)',
            dataField: 't_nw_p',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 14,
            visible: true,
            format:  '###,###,###,###,##0.00'
        },
        {
            name: 't_nw_k',
            caption: 'Температура воздуха тоннеля для потерь (С)',
            dataField: 't_nw_k',
            allowEditing: true,
            dataType: 'number',
            width: 150,
            index: 15,
            visible: true,
            format:  '###,###,###,###,##0.00'
        }
    ],
    api: {
        select: 'tep-nsi./tep-nsi/ds-period/select/get',
        save: 'tep-nsi./tep-nsi/ds-period/save/set',
    },
    viewId: 'ds-period-view',
    isFilterPanelVisible: false,
    selectionMode: 'single',
}

</script>
<style scoped>

</style>
